/** Shared helpers for dashboard admin CRUD + public list endpoints */

export function unwrapList(res) {
  const d = res?.data;
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data)) return d.data;
  return [];
}

export function unwrapOne(res) {
  const d = res?.data;
  if (d?.data != null && typeof d.data === "object" && !Array.isArray(d.data)) {
    return d.data;
  }
  const singleKeys = ["news", "product", "service", "partner", "reference"];
  for (const k of singleKeys) {
    const v = d?.[k];
    if (v != null && typeof v === "object" && !Array.isArray(v)) return v;
  }
  return d;
}

export function cloneFormData(source) {
  const fd = new FormData();
  source.forEach((value, key) => {
    fd.append(key, value);
  });
  return fd;
}

export const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://alnabaatech.com.ly";

export function resolveStorageUrl(raw) {
  if (!raw || typeof raw !== "string") return "";
  const trimmed = raw.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  const path = trimmed.replace(/^\//, "");
  if (path.startsWith("storage/")) {
    return `${API_BASE.replace(/\/$/, "")}/${path}`;
  }
  return `${API_BASE.replace(/\/$/, "")}/storage/${path}`;
}

export function formatValidationErrors(err) {
  const res = err?.response?.data;
  if (res?.errors && typeof res.errors === "object") {
    const lines = Object.entries(res.errors).flatMap(([key, messages]) => {
      const arr = Array.isArray(messages) ? messages : [messages];
      return arr.map((m) => `${key}: ${m}`);
    });
    return lines.length ? lines.join("\n") : res.message || "Validation failed.";
  }
  if (res?.message) return String(res.message);
  return err?.message || "Request failed.";
}
